<template>
  <div>


<h2 class="goth sune">Prepositioner i speciella verbkonstruktioner</h2>

<div class="grammatikparagrafbredd leftorient">
<p>Till många abstrakta verbuttryck hör en specifik preposition. Vilken preposition som används är ofta olika
    från språk till språk. I tyskan måste man dessutom tänka på vilket kasus följande prepositionsobjekt kommer att stå i. </p>

<p>Här listar vi några vanliga sådana uttryck och tillhörande preposition och kasus.</p>

<div class="quasi-p">Prepositionerna <div class="inlajn gron"><i><b>durch, für, gegen, ohne, um </b></i></div> styr alltid
    <div class="inlajn gron"> <b>ackusativ</b> </div>. Följaktligen står prepositionsobjekten i uttryck med något av dem i ackusativ:</div>

<table class="">

    <tr>
        <td class="ljusgra">
            <i><b>für</b> / <b>gegen</b> etwas <div class="inlajn gron">(ack)</div> sein</i>
        </td>
        <td class="ljusgra">
            vara för/emot något
        </td>
    </tr>


</table>
<br><br>
<div class="quasi-p">Prepositionerna <div class="inlajn rod"><i><b>aus, außer,bei, gegenüber, mit, nach, seit, von, zu </b></i></div> styr alltid
    <div class="inlajn rod"> <b>dativ</b> </div>. Följaktligen står prepositionsobjekten i uttryck med något av dem i dativ</div>

<table class="">

    <tr>
        <td class="ljusgra">
            <i>beschäftigt sein <b>mit</b> + <div class="inlajn rod"> dativ</div> </i>
        </td>
        <td class="ljusgra">
            vara sysselsatt med
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>rechnen <b>mit</b> + <div class="inlajn rod"> dativ</div> </i>
        </td>
        <td class="ljusgra">
            räkna med
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>sich sehnen <b>nach</b> + <div class="inlajn rod"> dativ</div> </i>
        </td>
        <td class="ljusgra">
            längta efter
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>abhängen <b>von</b> + <div class="inlajn rod"> dativ</div> </i>
        </td>
        <td class="ljusgra">
            bero på / hänga på (om framtid)
        </td>
    </tr>

</table>


<br><br>
<div class="quasi-p">Prepositionerna <div class="inlajn brun"><i><b>an, auf, hinter, in, neben, über, unter, vor, zwischen  </b></i></div>
styr styr ibland ackusativ, ibland dativ. I konkreta betydelser gäller som bekant vid riktning ackusativ (RiA)
och vid befintlighet dativ (BeDa). <i>När prepositionerna används vid abstrakta uttryck där det varken handlar om
    riktning eller befintlighet kan denna regel inte tillämpas på samma sätt.</i>
    Men vissa mönster kan ändå skönjas:</div>.

    <div class="quasi-p"><div class="inlajn brun"><i><b>auf</b></i></div> och <div class="inlajn brun"><i><b>über</b></i></div> styr i abstrakta fall <b>oftast</b>
        <div class="inlajn gron"> <b> ackusativ</b> </div>.</div>
<table class="">

    <tr>
        <td class="ljusgra">
            <i>verzichten <b>auf</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            avstå från
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>bestehen <b>auf</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            yrka på, envisas med
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>achten <b>auf</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            se upp med
        </td>
    </tr>



    <tr>
        <td class="ljusgra">
            <i>sich (<div class="inlajn gron">ack</div>) ärgern <b>über</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            bli arg på, reta sig på
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>sich (<div class="inlajn gron">ack</div>) freuen <b>über</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            glädja sig åt något (nutid)
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>sich (<div class="inlajn gron">ack</div>) freuen <b>auf</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            glädja sig åt något (framtid) / se fram emot något
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>sich (<div class="inlajn gron">ack</div>) verlassen <b>auf</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            lita på
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>ankommen <b>auf</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            bero på
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>warten <b>auf</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            vänta på
        </td>
    </tr>



</table>

<br>
<div class="quasi-p"><div class="inlajn brun"><i><b>vor</b></i></div> och <div class="inlajn brun"><i><b>an</b></i></div> styr i abstrakta fall <b>oftast</b>
    <div class="inlajn rod"> <b> dativ</b> </div>.</div>


<table class="" style="width:100%">
    <tr>
        <td class="ljusgra">
            <i>Angst haben <b>vor</b> + <div class="inlajn rod"> dativ</div> </i>
        </td>
        <td class="ljusgra">
            vara rädd för
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <i>zweifeln <b>an</b> + <div class="inlajn rod"> dativ</div> </i>
        </td>
        <td class="ljusgra">
            tvilva på
        </td>
    </tr>


</table>
<br>
<p>Men jämför</p>
<table class="" style="width:100%">
    <tr>
        <td class="ljusgra">
            <i>denken <b>an</b> + <div class="inlajn gron"> ackusativ</div> </i>
        </td>
        <td class="ljusgra">
            tänka på
        </td>
    </tr>
</table>

<p class="mindre">En krystad förklaringsmodell till ovanstående går ut på
    föreställningen att man riktar tanken mot någon,
    varpå ackusativ självklart skulle användas</p>









</div>


</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
